import React from 'react'

import { Textarea } from 'ui/components/Textarea'

export const LongTextDefaultValue: React.FC<{
    value: FieldDto['default_value']
    onChange: (value: FieldDto['default_value']) => void
}> = ({ value, onChange }) => {
    const editorRef = React.useRef<any>()

    return (
        <Textarea
            richText={false}
            ref={editorRef}
            size="m"
            autoSize
            value={value?.value}
            onChange={(e) => {
                const value = e.target.value
                onChange({ type: 'constant', value: value })
            }}
            width="full"
        />
    )
}
